import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

export default function useUnderPerformingUrlsExp() {
	const languageStore = useLanguageStore();
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_UNDERPERFORMING_URLS');

	function setUnderPerformingUrlsExpTags(url: ClickoutUrl, placement: 'ft' | 'sqtv' | 'qtv', shortName: string) {
		if (!variant.value) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: languageStore.country,
			placement,
			providerShortName: shortName,
		});

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		setUnderPerformingUrlsExpTags,
	};
}
